import { gql } from '@apollo/client';
import each from 'lodash/each';
import BaseService from './baseService';

class BenefitService extends BaseService {
  constructor() {
    super();
    this.programDataMappings = {
      programId: {
        name: '$programId',
        type: 'Int',
        input: 'programId'
      },
      programName: {
        name: '$programName',
        type: 'String',
        input: 'programName',
        typeRequire: 'String!'
      },
      programStartDate: {
        name: '$programStartDate',
        type: 'DateTime',
        input: 'programStartDate',
        typeRequire: 'DateTime!'
      },
      programEndDate: {
        name: '$programEndDate',
        type: 'DateTime',
        input: 'programEndDate',
        typeRequire: 'DateTime!'
      },
      dispatchServiceAll: {
        name: '$dispatchServiceAll',
        type: 'Int',
        input: 'dispatchServiceAll',
        typeRequire: 'Int!'
      },
      priceBookId: {
        name: '$priceBookId',
        type: 'Int',
        input: 'priceBookId',
        typeRequire: 'Int!'
      },
      dispatchMemberValidation: {
        name: '$dispatchMemberValidation',
        type: 'String',
        input: 'dispatchMemberValidation'
      }
    };
    this.beneftiCateoryGql = `
      dispatchBenefitCategoriesId
      name
    `;
    this.beneftiTypeGql = `
      dispatchBenefitTypeId
      name
    `;
  }

  buildProgramGQL = (data, mutation, required, actionReturned) => {
    const keys = Object.keys(data);
    const program = [];
    const input = [];
    each(keys, (key) => {
      const map = this.programDataMappings[key];
      if (map && data[key] !== null && data[key] !== undefined && data[key] !== 'undefined') {
        program.push(
          `${map.name}: ${
            required && map.typeRequire ? map.typeRequire : map.type
          }`
        );
        input.push(`${map.input}: ${map.name}`);
      }
    });
    return `
      mutation Program(${program.join(', ')}){
        ${mutation}(
            ${input.join('\n')}
          ) {
            ${actionReturned ? this.programActionGql : this.programGql}
        }
    }`;
  };

  getBenefitCategories = () => new Promise((resolve, reject) => {
    const CATEGORIES = gql`
      query {
        benefitCategories{
            ${this.beneftiCateoryGql}
        }
    }`;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: CATEGORIES
      })
      .then((result) => {
        if (result.data.benefitCategories) {
          resolve(result.data.benefitCategories);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getBenefitTypes = () => new Promise((resolve, reject) => {
    const TYPES = gql`
      query {
        benefitTypes{
            ${this.beneftiTypeGql}
        }
    }`;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: TYPES
      })
      .then((result) => {
        if (result.data.benefitTypes) {
          console.log('getBenefitTypes', result.data);
          resolve(result.data.benefitTypes);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });
}

const benefitService = new BenefitService();

export default benefitService;
